import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_NOTIFICATION_CONFIGS,
  RECEIVE_USER_NOTIFICATION_CONFIGS,
  SET_USER_NOTIFICATION_CONFIGS_LOADING,
  CONFIG_CREATED,
  CONFIG_UPDATED,
  CONFIG_DELETED,
  SET_NOTIFICATION_CONFIGS_LOADING,
  SET_COPIED_SETTINGS,
  CLEAR_COPIED_SETTINGS,
} from './actions';

const initialState = {
  configs: [], // role configs (user == null)
  total: 0,
  isLoading: false,
  userConfigs: [], // user-level override configs (user != null)
  userConfigsTotal: 0,
  isUserConfigsLoading: false,
  copiedSettings: null,
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_NOTIFICATION_CONFIGS: {
      return { ...state, configs: action.configs, total: action.total };
    }
    case RECEIVE_USER_NOTIFICATION_CONFIGS: {
      return { ...state, userConfigs: action.configs, userConfigsTotal: action.total };
    }
    case SET_USER_NOTIFICATION_CONFIGS_LOADING: {
      return { ...state, isUserConfigsLoading: action.loading };
    }
    case CONFIG_CREATED: {
      // Route to the correct list based on whether it's a user or role config
      if (action.config.user != null) {
        return {
          ...state,
          userConfigs: [action.config, ...state.userConfigs],
          userConfigsTotal: state.userConfigsTotal + 1,
        };
      }
      return { ...state, configs: [action.config, ...state.configs], total: state.total + 1 };
    }
    case CONFIG_UPDATED: {
      const inUserConfigs = state.userConfigs.some((c) => c.id === action.config.id);
      if (inUserConfigs) {
        return {
          ...state,
          userConfigs: state.userConfigs.map((c) =>
            c.id === action.config.id ? action.config : c
          ),
        };
      }
      return {
        ...state,
        configs: state.configs.map((c) => (c.id === action.config.id ? action.config : c)),
      };
    }
    case CONFIG_DELETED: {
      const inUserConfigs = state.userConfigs.some((c) => c.id === action.id);
      if (inUserConfigs) {
        return {
          ...state,
          userConfigs: state.userConfigs.filter((c) => c.id !== action.id),
          userConfigsTotal: Math.max(0, state.userConfigsTotal - 1),
        };
      }
      return {
        ...state,
        configs: state.configs.filter((c) => c.id !== action.id),
        total: Math.max(0, state.total - 1),
      };
    }
    case SET_NOTIFICATION_CONFIGS_LOADING: {
      return { ...state, isLoading: action.loading };
    }
    case SET_COPIED_SETTINGS: {
      return { ...state, copiedSettings: action.copiedSettings };
    }
    case CLEAR_COPIED_SETTINGS: {
      return { ...state, copiedSettings: null };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
